export function ReportTab({ children }) {
  return children;
}
